import React from 'react';
import { motion } from 'framer-motion';

const SocialProofBar: React.FC = () => {
  return (
    <section className="bg-gradient-to-r from-mas10-primary to-mas10-secondary py-4">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center text-white"
        >
          <div className="text-base md:text-lg lg:text-xl text-white font-medium">
            <span className="font-bold">Cientos de profesionales</span> del entrenamiento y la salud, conectados con <span className="font-bold">deportistas</span>, equipos e <span className="font-bold">instituciones</span> deportivas.
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProofBar;
